import { render, staticRenderFns } from "./DiscountTag.vue?vue&type=template&id=ee97631e&scoped=true"
import script from "./DiscountTag.vue?vue&type=script&lang=js"
export * from "./DiscountTag.vue?vue&type=script&lang=js"
import style0 from "./DiscountTag.vue?vue&type=style&index=0&id=ee97631e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee97631e",
  null
  
)

export default component.exports